<div class="price-editor-label"
  [ngClass]="[labelClass, effectiveTrend > 0 ? 'label-trend-inc' : effectiveTrend < 0 ? 'label-trend-dec' : '']"
  *ngIf="label">
  <span>{{ label }}</span>
  <span class="text-danger" *ngIf="isExceedRange">(*)</span>
  <span *ngIf="isCustomPriceActive" class="badge-override">EDITED</span>
</div>

<!-- Missing price prompt -->
<div *ngIf="!isEditing && isMissingPrice && !customPrice" class="missing-price-prompt" (click)="!isReadOnly && onEditToggle(priceInput)">
  <i class="fas fa-exclamation-triangle missing-price-icon"></i>
  <span class="missing-price-text">No price set — click to enter</span>
</div>

<!-- Default state: price value + badges + pencil -->
<div class="price-row" *ngIf="!isEditing && (!isMissingPrice || customPrice)">
  <div class="price-with-edit">
    <span class="price-lg" [ngClass]="[priceClass, effectiveTrend > 0 ? 'text-new-inc' : effectiveTrend < 0 ? 'text-new-dec' : 'text-dark']">
      <ng-container *ngIf="customPrice != null">{{ customPrice | currency : displayCurrency?.code : displayCurrency?.symbol : "1.2" }}</ng-container>
      <ng-container *ngIf="customPrice == null">{{ nullPlaceholder }}</ng-container>
    </span>
    <button *ngIf="!isReadOnly" class="btn-edit-icon" (click)="onEditToggle(priceInput)" title="Edit price" type="button">
      <svg class="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" style="width: 12px; height: 12px; stroke-width: 2.5;">
        <path stroke-linecap="round" stroke-linejoin="round" d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
      </svg>
    </button>
  </div>

  <app-repricing-trend-badge
    *ngIf="showTrendBadge && (!isExceedRange || isCustomPriceActive)"
    [trendPercentage]="isCustomPriceActive ? effectiveTrend : trendPercentage"
    [isMuted]="false">
  </app-repricing-trend-badge>
  <ng-content></ng-content>
</div>

<div *ngIf="showSuggestedPrice && !isEditing && isCustomPriceActive && targetPrice" class="price-editor-suggested">
  Suggested: {{ targetPrice | currency : displayCurrency?.code : displayCurrency?.symbol : "1.2" }}
</div>

<!-- Edit state: input row, then badges row -->
<div [hidden]="!isEditing">
  <div class="d-flex align-items-center flex-wrap gap-2 mt-1 mb-2">
    <div class="input-group input-group-sm price-input-group" [ngClass]="{ 'has-error': validationError, 'is-missing': isMissingPrice && !customPrice }">
      <div class="input-group-prepend">
        <span class="input-group-text font-weight-bold">{{ displayCurrency?.symbol || '$' }}</span>
      </div>
      <input
        #priceInput
        type="number" step="0.1" min="0"
        class="form-control font-weight-bold"
        [ngClass]="{ 'text-danger': validationError }"
        [(ngModel)]="customPrice"
        (ngModelChange)="onPriceChange($event)"
        (blur)="onBlur()"
        (keydown.enter)="onBlur()"
      />
      <div class="input-group-append ml-0">
        <button class="btn btn-reset-override btn-sm" type="button" (mousedown)="$event.preventDefault()" (click)="onReset()" title="Reset to suggested">
          <svg class="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" style="width: 13px; height: 13px; stroke-width: 2.5;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 3v5h5" />
          </svg>
        </button>
      </div>
    </div>

    <app-repricing-trend-badge
      *ngIf="showTrendBadge && (!isExceedRange || isCustomPriceActive)"
      [trendPercentage]="isCustomPriceActive ? effectiveTrend : trendPercentage"
      [isMuted]="false">
    </app-repricing-trend-badge>
  </div>
  
  <div *ngIf="showSuggestedPrice && targetPrice" class="price-editor-suggested">
    Suggested: {{ targetPrice | currency : displayCurrency?.code : displayCurrency?.symbol : "1.2" }}
  </div>

  <div *ngIf="validationError" class="text-danger small mt-1 mb-2" style="line-height: 1.2;">
    {{ validationError }}
  </div>

  <div *ngIf="isMissingPrice && !validationError" class="missing-price-helper">
    Enter a price to enable syncing.
  </div>
</div>
